import type { AnyAction } from "redux";
import type { ISegmentsData } from "app/services/conversion/ConversionSegmentsService";
import {
    RECEIVE_SEGMENTS_DATA,
    REQUEST_SEGMENTS_DATA,
    UPDATE_SEGMENT_DATA,
    DELETE_SEGMENT_DATA,
    TOGGLE_DELETE_SEGMENT_GROUP_MODAL,
    TOGGLE_RENAME_SEGMENT_GROUP_MODAL,
} from "app/action_types/conversion_module_action_types";

export interface IConversionModuleState {
    deleteGroupSegmentModalIsOpen: boolean;
    renameGroupSegmentModalIsOpen: boolean;
    gid: string | undefined;
    segments?: ISegmentsData;
    segmentsLoading: false;
}

/**
 * Get default state. id the screen width is less than 1200px, the sidebar is closed by default;
 * @returns {ILayoutState}
 */
function getDefaultState(): IConversionModuleState {
    return {
        deleteGroupSegmentModalIsOpen: false,
        renameGroupSegmentModalIsOpen: false,
        gid: undefined,
        // segments key is presented from bootstrap
        segmentsLoading: false,
    };
}

function conversionModule(incomingState: IConversionModuleState | undefined, action: AnyAction): IConversionModuleState {
    const state: IConversionModuleState = incomingState || getDefaultState();
    switch (action.type) {
        case TOGGLE_DELETE_SEGMENT_GROUP_MODAL: {
            return {
                ...state,
                deleteGroupSegmentModalIsOpen: action.isOpen,
                gid: action.gid,
            };
        }
        case TOGGLE_RENAME_SEGMENT_GROUP_MODAL: {
            return {
                ...state,
                renameGroupSegmentModalIsOpen: action.isOpen,
                gid: action.gid,
            };
        }
        case RECEIVE_SEGMENTS_DATA:
            return {
                ...state,
                segments: action.segments,
                segmentsLoading: action.segmentsLoading,
            };
        case REQUEST_SEGMENTS_DATA:
            return {
                ...state,
                segmentsLoading: action.segmentsLoading,
            };
        case DELETE_SEGMENT_DATA: {
            // @ts-ignore FIXME: strict migration
            const { [action.id]: removedGroup, ...segmentGroupsAfterRemoval } = state.segments.segmentGroups;
            return {
                ...state,
                // @ts-ignore FIXME: strict migration
                segments: {
                    ...state.segments,
                    segmentGroups: { ...segmentGroupsAfterRemoval },
                },
            };
        }
        case UPDATE_SEGMENT_DATA:
            if (action.isNew) {
                return {
                    ...state,
                    // @ts-ignore FIXME: strict migration
                    segments: {
                        ...state.segments,
                        segmentGroups: {
                            // @ts-ignore FIXME: strict migration
                            ...state.segments.segmentGroups,
                            [action.segment.id]: {
                                id: action.segment.id,
                                segments: [...action.segment.segments],
                                name: action.segment.name,
                                creationType: action.segment.creationType,
                            },
                        },
                    },
                };
            } else {
                // @ts-ignore FIXME: strict migration
                const existingSegmentGroup = state.segments.segmentGroups[action.segment.id];
                return {
                    ...state,
                    // @ts-ignore FIXME: strict migration
                    segments: {
                        ...state.segments,
                        segmentGroups: {
                            // @ts-ignore FIXME: strict migration
                            ...state.segments.segmentGroups,
                            [existingSegmentGroup.id]: {
                                id: existingSegmentGroup.id,
                                segments: action.segment.segments
                                    ? [...action.segment.segments]
                                    : [...existingSegmentGroup.segments],
                                name: action.segment.name,
                                creationType: existingSegmentGroup.creationType,
                            },
                        },
                    },
                };
            }
        default:
            return state;
    }
}

export default conversionModule;
